import { useEffect, useState } from "react";
import axios from "axios";

export default function CategoryBanner() {
    const [banner, setBanner] = useState(null);

    useEffect(() => {
        axios.get("/api/banner?slot=below_categories")
            .then(res => setBanner(res.data))
            .catch(() => setBanner(null));
    }, []);

    if (!banner) return null;

    const media = banner.media_type === "image"
        ? <img src="/api/banner/media?slot=below_categories" alt="banner" className="w-full h-full object-cover" />
        : <video src="/api/banner/media?slot=below_categories" autoPlay loop muted playsInline className="w-full h-full object-cover"></video>;

    const frame = "block w-full max-w-[1140px] aspect-[935/60] overflow-hidden rounded-[4px]";

    return (
        <div className="w-full flex justify-center py-4 px-4 md:px-6">
            {banner.link ? (
                <a
                    href={banner.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={frame}
                    onClick={() => navigator.sendBeacon('/api/click/banner/below_categories')}
                >
                    {media}
                </a>
            ) : (
                <div className={frame}>
                    {media}
                </div>
            )}
        </div>
    );
}
